'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _index = require('components/index');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var uploaderStyles = require('components/FineUploader/FineUploader.scss');

var CloudUploadStatusIcon = (_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CloudUploadStatusIcon, _Component);

  function CloudUploadStatusIcon() {
    var _ref;

    (0, _classCallCheck3.default)(this, CloudUploadStatusIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = CloudUploadStatusIcon.__proto__ || (0, _getPrototypeOf2.default)(CloudUploadStatusIcon)).call.apply(_ref, [this].concat(args)));

    _this.state = { processingStatus: false };
    return _this;
  }

  (0, _createClass3.default)(CloudUploadStatusIcon, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unmounted = true;
    }
  }, {
    key: 'setProcessing',
    value: function setProcessing(val) {
      if (!this.unmounted) {
        this.setState({ processingStatus: val });
      }
    }
  }, {
    key: 'deleteFile',
    value: function deleteFile() {
      var _this2 = this;

      var onDelete = this.props.onDelete;

      this.setProcessing(true);
      onDelete().then(function () {
        return _this2.setProcessing(false);
      }).catch(function () {
        return _this2.setProcessing(false);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          deletable = _props.deletable,
          status = _props.status;
      var processingStatus = this.state.processingStatus;

      var renderRes = null;

      if (!status || processingStatus) {
        renderRes = _react2.default.createElement(_index.Loader, { size: 16 });
      } else if (status === 'success') {
        renderRes = deletable ? _react2.default.createElement('i', { className: (0, _bind2.default)('statusIcon', className, uploaderStyles.statusIcon, 'icon-close colorError'), onClick: this.deleteFile }) : _react2.default.createElement('i', { className: (0, _bind2.default)('statusIcon', className, uploaderStyles.statusIcon, 'icon-check colorSuccess') });
      } else {
        renderRes = _react2.default.createElement('i', { className: (0, _bind2.default)('statusIcon', className, uploaderStyles.statusIcon, 'icon-warning colorError') });
      }

      return _react2.default.createElement(
        'span',
        { className: (0, _bind2.default)('statusIconContainer', uploaderStyles.statusIconContainer) },
        renderRes
      );
    }
  }]);
  return CloudUploadStatusIcon;
}(_react.Component), _class2.propTypes = {
  className: _propTypes2.default.string,
  deletable: _propTypes2.default.bool,
  onDelete: _propTypes2.default.func,
  status: _propTypes2.default.string
}, _class2.defaultProps = {
  onDelete: function onDelete() {}
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'deleteFile', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteFile'), _class.prototype)), _class);
exports.default = CloudUploadStatusIcon;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Cloud/CloudUploadStatusIcon/CloudUploadStatusIcon.js
// module id = 1970
// module chunks = 1